import { Component, Inject } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router";
import { AuthServices, AppServices } from "@services";

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  styleUrls: ['./error404.component.scss']
})

export class Error404Component {

  _error_404_route_url: string = null;

  constructor(
    @Inject('AuthServices') private _authServices: AuthServices,
    @Inject('AppServices') private _appServices: AppServices,
    private router: Router
  ) {

    //Get the Last Page before 404
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          //  console.log('NavigationEnd:', event);
          if (event.url != '/404'){
            this._error_404_route_url = event.url;
          }
          
        }
      });

  }

  ngOnInit() {

    //this.Reconnect();
    //setTimeout('history.back()', 1000*5)
  }

  Reconnect() {
    // this.router.navigate(['login']);    
    setTimeout('history.back()', 100)
  }


}